<template>
  <div class="geo-location-widget" @click.stop="openGeoLocationsPopup()" v-if='isNoDataToShow'>
    <div class="geo-location-widget__title">
      {{this.$t(title)}}
    </div>
    <v-divider />
    <div class="geo-location-widget__data">
      <div v-for='(country, i) in sortedList' class='geo-location-widget__data__row' :key='`geo-location-widget__data__row-${i}`'>
        <country-flag
          rounded
          :country='country.countryCode'
          size='small' />
        <div class='geo-location-widget__data__row__name' v-html='`${country.countryName}`' />
        <div class='geo-location-widget__data__row__count' v-html='`${country.count}`' />
      </div>
    </div>
  </div>
</template>

<script>
import CountryFlag from 'vue-country-flag';

export default {
  name: 'GeoLocationsWidget',
  props: {
    locations: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  components: {
    CountryFlag,
  },
  computed: {
    title() {
      return 'geo.locations.widget.title';
    },
    sortedList() {
      return Object.keys(this.locations).sort((a, b) => this.locations[b].count - this.locations[a].count).map(key => this.locations[key]).slice(0, 3);
    },
    isNoDataToShow() {
      return this.sortedList.length > 0;
    },
  },
  methods: {
    openGeoLocationsPopup() {
      this.$emit('openGeoLocationsPopup');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.geo-location-widget {
  min-width: rem(230);
  max-width: rem(230);
  min-height: rem(150);
  max-height: rem(205);
  display: flex;
  flex-direction: column;
  border-radius: $radius-md;
  background-color: var(--bg-secondary);

  &__title {
    color: var(--text-secondary);
    font-family: $font-family-regular;
    font-size: $font-size-sm;
    padding: rem(20) rem(25) 0;
    text-transform: uppercase;
    margin-bottom: rem(7);
    letter-spacing: 1.1px;
    line-height: rem(15);
  }

  &__data {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    max-height: rem(155);
    margin-left: rem(25);
    margin-right: rem(25);
    margin-bottom: $space-2;
    justify-content: space-between;

    &__row {
      display: flex;
      flex-direction: row;
      align-items: center;

      &__name {
        margin-left: $space-1;
        min-width: rem(100);
        font-family: $font-family-semibold;
        font-size: $font-size-sm;
        color: var(--text-primary);
      }

      &__count {
        display: flex;
        flex-grow: 1;
        flex-shrink: 1;
        justify-content: right;
        font-family: $font-family-semibold;
        font-size: $font-size-base;
        color: var(--text-secondary);
      }
    }
  }

  &:hover {
    cursor: pointer;
  }
}
</style>

<style lang="scss">
@import '~@/assets/styles/design-system';

.geo-location-widget {
  .v-divider {
    margin-left: rem(25) !important;
    margin-right: rem(25) !important;
    margin-bottom: $space-4;
  }
}
</style>
